import { css } from '@emotion/react';
import { colors, fonts, StyleTheme } from '../../../shared/global';
import { media } from '../../../shared/services/media';

export const theme: StyleTheme = {
    body: {
        color: colors.scorpion,
        fontFamily: fonts.gothamRounded,
        backgroundColor: colors.bonJour,
    },
    headings: {
        fontFamily: fonts.gothamRoundedBook,
    },
    versionSpecificGlobalStyles: css`
        body {
            font-weight: 300;
            line-height: 1.5;

            ${media.max('md')} {
                font-size: 16px;
            }

            ${media.between('md', 'xl')} {
                font-size: 20px;
            }

            ${media.min('xl')} {
                font-size: 24px;
            }
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font-weight: 400;
        }
    `,
};
